export const DISCOUNT_FILTER_ID = 'discounts';
